"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Admin = void 0;

Admin = function () {
    function eduActions() {
        (0, _jquery2.default)("#toggleApp").on("click", function (e) {
            e.preventDefault();

            _jquery2.default.ajax({
                url: window.location.href,
                type: "POST",
                data: JSON.stringify({ type: "toggle" }),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function success(data, status, xhr) {
                    window.location.reload();
                }
            });
        });
        (0, _jquery2.default)("#toggleAppEmail").on("click", function (e) {
            e.preventDefault();

            _jquery2.default.ajax({
                url: window.location.href,
                type: "POST",
                data: JSON.stringify({ type: "toggle_and_email" }),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function success(data, status, xhr) {
                    window.location.reload();
                }
            });
        });
    }
    function Admin() {
        (0, _jquery2.default)("document").ready(function () {
            eduActions();

            var $admin_sidebar = void 0;
            var $admin_status_header = void 0;
            var $footer = void 0;
            var $is_active = void 0;
            var $main_content = void 0;
            var $search = void 0;
            var $sticky_wrapper = void 0;
            var click_count = void 0;
            var disable_property = void 0;
            var toggle = void 0;
            toggle = 0;
            $admin_sidebar = (0, _jquery2.default)("#admin-sidebar");
            $admin_status_header = (0, _jquery2.default)("#admin-stats-header");
            $search = (0, _jquery2.default)("#search");
            $sticky_wrapper = (0, _jquery2.default)(".sticky-wrapper");
            $main_content = (0, _jquery2.default)("#main-content");
            $footer = (0, _jquery2.default)("#footer");
            $is_active = (0, _jquery2.default)(".is_active");
            disable_property = function disable_property(me, property) {
                var $this = void 0;
                var prop = void 0;
                var url = void 0;
                $this = (0, _jquery2.default)(me);
                $this.property = property;
                prop = $this.data(property);
                if (property === "id") {
                    url = "/json_disable_icon/" + prop + "/";
                } else {
                    url = "/fort/members/disable/" + prop + "/";
                }
                return _jquery2.default.ajax({
                    url: url,
                    type: "POST",
                    success: function success(data, status, xhr) {

                        if ($this.property === "id") {
                            data.message = "The Icon was disabled";
                        }
                        $this.text(data.message);
                        if (data.status !== "error") {
                            $is_active.text("False");
                        }
                        return $this.addClass("disabled");
                    },
                    error: function error(xhr, status, _error) {
                        return console.log(_error);
                    }
                });
            };
            click_count = 0;
            (0, _jquery2.default)("#disable_user").on("click", function (e) {
                var $this = void 0;
                e.preventDefault();
                click_count++;
                $this = (0, _jquery2.default)(this);
                switch (click_count) {
                    case 1:
                        return $this.text("Are you sure?");
                    case 2:
                        return disable_property(this, "user_id");
                }
            });
            (0, _jquery2.default)("#disable_icon").on("click", function (e) {
                e.preventDefault();
                return disable_property(this, "id");
            });
            return (0, _jquery2.default)("#sandwich-stack").on("click", function (e) {
                e.preventDefault();
                if (toggle === 0) {
                    $admin_status_header.css("left", "300px");
                    $sticky_wrapper.css("left", "300px");
                    $search.css("left", "300px");
                    $main_content.css("left", "300px");
                    $footer.css("left", "300px");
                    $admin_sidebar.css("left", "0");
                    return toggle = 1;
                } else {
                    $admin_status_header.css("left", "0");
                    $sticky_wrapper.css("left", "0");
                    $search.css("left", "0");
                    $main_content.css("left", "0");
                    $footer.css("left", "0");
                    $admin_sidebar.css("left", "-300px");
                    return toggle = 0;
                }
            });
        });
    }

    return Admin;
}();

exports.default = Admin;